import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Confirmation = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const bookingRef = searchParams.get("bookingRef");
  const status = searchParams.get("status");
  const auth = searchParams.get("auth");
  const order = searchParams.get("order");

  const amountConfirmed = searchParams.get("amountConfirmed");
  const amountAuthorized = searchParams.get("amountAuthorized");

  let [isConfirming, setIsconfirming] = useState(true);

  //  const res = JSON.parse(term!);

  console.log("====================================");
  //  console.log("LOCATION: ", res);
  console.log("====================================");

  useEffect(() => {}, []);
  return <div></div>;
};

export default Confirmation;
